import * as React from "react";
import Theme from "../../../vars/ThemeOptions";
import styled from "styled-components";
import { colors } from "../../../vars/palette";

const SubHeadWrap = styled.h2<{ textCase?: "uppercase" | "none" }>`
  text-transform: ${({ textCase }) => textCase};
  color: ${colors.hex("secondary")};
  font-family: ${({ textCase }) =>
    textCase === "none" ? `Nunito Sans` : Theme.font.head};
  font-weight: 700;
  &.reverse {
    color: ${colors.hex("reverse")};
  }
`;

const SubHeading = ({
  text,
  reverse = false,
  textCase = "uppercase",
}: {
  text: string;
  reverse?: boolean;
  textCase?: "uppercase" | "lowercase";
}) => {
  const colorClass = reverse ? " reverse" : "";
  return (
    <SubHeadWrap
      className={"block-title" + colorClass}
      textCase={textCase === "lowercase" ? "none" : textCase}
    >
      {text}
    </SubHeadWrap>
  );
};

export default SubHeading;
